import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

const CHANNELS = [["TELEFONE", "Telefone"], ["WHATSAPP", "WhatsApp"], ["PRESENCIAL", "Presencial"], ["EMAIL", "E-mail"]];

export function FamilyContactDialog({ studentId, description, open, onClose, onSaved }) {
  const [channel, setChannel] = useState("TELEFONE");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (note.trim().length < 3) { toast.error("Descreva o que foi conversado com a família"); return; }
    setSaving(true);
    try {
      await api.post(`/students/${studentId}/family-contact`, { channel, note: note.trim() });
      toast.success("Contato com a família registrado");
      setNote(""); setChannel("TELEFONE");
      onSaved?.(); onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Falha ao registrar contato");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="family-contact-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Registrar contato com a família</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Canal de contato</Label>
            <Select value={channel} onValueChange={setChannel}>
              <SelectTrigger data-testid="family-contact-channel"><SelectValue /></SelectTrigger>
              <SelectContent>
                {CHANNELS.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`family-contact-channel-${v}`}>{l}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label>O que foi conversado</Label>
            <Textarea value={note} onChange={(e) => setNote(e.target.value)} maxLength={1000} rows={4}
              placeholder="Ex.: Mãe informou que o aluno está doente e retorna na segunda-feira."
              data-testid="family-contact-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="family-contact-cancel">Cancelar</Button>
          <Button onClick={save} disabled={saving} className="bg-orange-500 hover:bg-orange-600" data-testid="family-contact-save">
            {saving ? "Salvando..." : "Registrar contato"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
